import React from 'react';
import {DonateIntro} from './DonateIntro'

export const DonateItemsFirstView = () => {
    return (
        <section id="userDonateFirstView">
            <div className="container">
                <DonateIntro/>
            </div>
        </section>
    )
}